import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, } from 'rxjs/operators';

import { InvitesService } from '../../services/invites.service';
import * as InviteActions from '../actions/invite.actions';

@Injectable()
export class InviteEffects {

  retrieveInvites$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InviteActions.retrieve),
      switchMap(() =>
        this.invitesService.getInviteMember().pipe(
          map((result) => {
            if (result) {
              const { invites_accepts, ...inviteMember } = result;
              return InviteActions.retrieveSuccess({ invites: invites_accepts, inviteMember });
            } else {
              return InviteActions.create();
            }
          }),
          catchError((error) =>
            of(InviteActions.retrieveFailure({error}))
          )
        )
      )
    )
  );

  createInviteMember$ = createEffect(() =>
    this.actions$.pipe(
      ofType(InviteActions.create),
      switchMap(() =>
        this.invitesService.createInvite().pipe(
          map(() => {
            return InviteActions.retrieve();
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private invitesService: InvitesService
  ) {}
}
